import { createFileRoute } from '@tanstack/react-router'

import { requireAdmin } from '@/auth/guards'
import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { InvitationsPanel } from '@/components/team/invitations-panel'
import { MembersTable } from '@/components/team/members-table'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface TeamSearch {
  tab: 'membres' | 'invitations'
}

export const Route = createFileRoute('/_app/team')({
  beforeLoad: requireAdmin,
  validateSearch: (search: Record<string, unknown>): TeamSearch => ({
    tab: search.tab === 'invitations' ? 'invitations' : 'membres',
  }),
  component: TeamPage,
})

function TeamPage() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="space-y-6">
      <PageHeader title="Équipe" />

      <Tabs
        value={tab}
        onValueChange={(value) => {
          void navigate({ search: { tab: value as TeamSearch['tab'] }, replace: true })
        }}
      >
        <TabsList>
          <TabsTrigger value="membres">Membres</TabsTrigger>
          <TabsTrigger value="invitations">Invitations</TabsTrigger>
        </TabsList>
        <TabsContent value="membres">
          <Frame>
            <MembersTable />
          </Frame>
        </TabsContent>
        <TabsContent value="invitations">
          <Frame>
            <InvitationsPanel />
          </Frame>
        </TabsContent>
      </Tabs>
    </div>
  )
}
